// extracted by mini-css-extract-plugin
module.exports = {"checkBoxContainer":"CompanyTimeOff_checkBoxContainer__1R1h2","buttonContainer":"CompanyTimeOff_buttonContainer__1VNxZ","input":"CompanyTimeOff_input__3vAJR"};